const SCRIPT_URL = 'https://google.com/recaptcha/enterprise.js';
const FALLBACK_SCRIPT_URL = 'https://recaptcha.net/recaptcha/enterprise.js';
export const getRecaptchaNameSpace = () => {
  var _grecaptcha;
  return window && window.grecaptcha && ((_grecaptcha = window.grecaptcha) === null || _grecaptcha === void 0 ? void 0 : _grecaptcha.enterprise) || undefined;
};
const createScriptElement = ({
  src,
  onError
}) => {
  const script = window.document.createElement('script');
  script.async = true;
  script.defer = true;
  script.type = 'text/javascript';
  script.onerror = onError;
  script.src = src;
  return script;
};
export const addRecaptchaScript = ({
  callbackId,
  locale
}) => {
  const script = createScriptElement({
    src: `${SCRIPT_URL}?&onload=${callbackId}&render=explicit&hl=${locale}`,
    onError: () => {
      const fallbackScript = createScriptElement({
        src: `${FALLBACK_SCRIPT_URL}?&onload=${callbackId}&render=explicit&hl=${locale}`,
        onError: e => {
          throw e;
        }
      });
      window.document.head.appendChild(fallbackScript);
    }
  });
  window.document.head.appendChild(script);
};
export const addRecaptchaV3Script = ({
  siteKey,
  locale,
  callbackId
}) => {
  const script = createScriptElement({
    src: `${SCRIPT_URL}?render=${siteKey}&hl=${locale}&onload=${callbackId}&badge=inline`,
    onError: () => {
      const fallbackScript = createScriptElement({
        src: `${FALLBACK_SCRIPT_URL}?render=${siteKey}&hl=${locale}&onload=${callbackId}&badge=inline`,
        onError: e => {
          throw e;
        }
      });
      window.document.head.appendChild(fallbackScript);
    }
  });
  window.document.head.appendChild(script);
};